module.exports = __webpack_public_path__ + "img/221.32bac065.jpg";